module.exports = __webpack_public_path__ + "built.gKTQl5Hs.png";